import { render, staticRenderFns } from "./CDG.vue?vue&type=template&id=3cc11dc4&scoped=true&"
import script from "./CDG.vue?vue&type=script&lang=js&"
export * from "./CDG.vue?vue&type=script&lang=js&"
import style0 from "./CDG.vue?vue&type=style&index=0&id=3cc11dc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc11dc4",
  null
  
)

export default component.exports